module.exports = __webpack_public_path__ + "static/img/wenhua3.826fb2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua3.jpg
// module id = e1pj
// module chunks = 1